import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';

import { Paper } from '@material-ui/core';

import Zone from 'components/shared/Zone';
import Stack from 'components/shared/Stack';

import Messages from './Messages';
import MessageEntry from './Messages/MessageEntry';
import LeadActions from './LeadActions';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import Loader from 'components/Loader';
import { LoadingStates } from 'typings';

type Props = {
  className?: string;
};

const ConversationPanel = ({ className }: Props) => {
  const communicationLoadingState = useSelector(
    (state: RootState) => state.lead.communicationLoadingState
  );

  return (
    <Stack className={cx('grid-panel', className)}>
      <Zone className="messages">
        {communicationLoadingState === LoadingStates.LOADING && <Loader />}
        {communicationLoadingState === LoadingStates.LOADED && <Messages />}
      </Zone>
      <Paper className="lead-actions" elevation={0}>
        <LeadActions />
      </Paper>
      <Paper className={cx('no-padding', 'message-entry')} elevation={0}>
        <MessageEntry />
      </Paper>
    </Stack>
  );
};

export default styled(ConversationPanel)`
  .messages {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    overflow: hidden;
    overflow-y: scroll;
    position: relative;
  }

  .lead-actions {
    margin-top: 0;
  }

  .message-entry {
    height: auto;
  }
`;
